module.exports = __webpack_public_path__ + "static/media/logo.567844e8.svg";